import { Link } from "react-router-dom";
import { Linkedin, Mail, Globe } from "lucide-react";

const nav = [
  { to: "/services", label: "Services" },
  { to: "/approach", label: "Approach" },
  { to: "/industries", label: "Industries" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 bg-[#0A1F44] text-white">
      <div className="mx-auto max-w-[1240px] px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-[1.2fr_0.8fr_1.2fr]">
          <div>
            <img
              src="/assets/revgengenius-lockup-white.png"
              alt="RevGen Genius"
              className="h-9 w-auto"
            />
            <p className="mt-5 max-w-sm text-[0.95rem] leading-relaxed text-white/70">
              Uniting sales, marketing, and customer success into one revenue engine.
            </p>
            <a
              href="https://www.linkedin.com/company/revgengenius"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="RevGen Genius on LinkedIn"
              data-testid="footer-linkedin-link"
              className="mt-6 inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white/80 transition-colors duration-200 hover:border-white hover:text-white"
            >
              <Linkedin size={19} />
            </a>
          </div>

          <nav aria-label="Footer">
            <h2 className="font-heading text-sm font-semibold uppercase tracking-[0.14em] text-white/50">
              Explore
            </h2>
            <ul className="mt-5 space-y-3">
              {nav.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                    className="text-[0.95rem] text-white/80 transition-colors duration-200 hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-semibold uppercase tracking-[0.14em] text-white/50">
              Contact
            </h2>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href="mailto:info@revgengenius.com"
                  data-testid="footer-email-link"
                  className="flex items-center gap-2.5 text-[0.95rem] text-white/80 transition-colors duration-200 hover:text-white"
                >
                  <Mail size={15} className="shrink-0 text-white/50" aria-hidden="true" />
                  info@revgengenius.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.revgengenius.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-website-link"
                  className="flex items-center gap-2.5 text-[0.95rem] text-white/80 transition-colors duration-200 hover:text-white"
                >
                  <Globe size={15} className="shrink-0 text-white/50" aria-hidden="true" />
                  www.revgengenius.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/15 pt-7 sm:flex-row sm:items-center">
          <p className="text-sm text-white/55">© 2026 RevGen Genius. All rights reserved.</p>
          <div className="flex gap-7">
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-sm text-white/55 transition-colors duration-200 hover:text-white">
              Privacy Policy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-white/55 transition-colors duration-200 hover:text-white">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
